import ImageWithCaptionCarouselBlock from './ImageWithCaptionCarouselBlock';

export default ImageWithCaptionCarouselBlock;
